import { ChangeDetectionStrategy, Component, input } from '@angular/core';
export type UiModalItemSummaryField = {
  label: string;
  value: string;
  tone?: 'default' | 'danger' | 'success' | 'muted';
};
@Component({
  selector: 'lib-ui-modal-item-summary',
  templateUrl: './ui-modal-item-summary.component.html',
  styleUrl: './ui-modal-item-summary.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiModalItemSummaryComponent {
   readonly fields = input<UiModalItemSummaryField[]>([]);
}
